/* 注册 窗口大小 改变事件 */
import { throttle } from 'throttle-debounce'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
function EventEmiter () {
  // 维护一个对象
  this._events = []
  return this
}

EventEmiter.prototype.resize = function (cb) {
  this._events.push(cb)
  return this
}

EventEmiter.prototype.off = function (cb) {
  let temp = []
  for (let i = 0; i < this._events.length; i++) {
    if (this._events[i] !== cb) {
      temp.push(this._events[i])
    }
  }
  this._events = temp
  return this
}

EventEmiter.prototype.emit = function () {
  if (this._events.length) {
    for (let i = 0; i < this._events.length; i++) {
      this._events[i]()
    }
  }
  return this
}

export default {
  data () {
    return {
      resizeHandle: new EventEmiter()
    }
  },
  beforeDestroy () {
    off(window, 'resize', this._resizeEventEmiter)
    this.resizeHandle = null
  },
  mounted () {
    on(window, 'resize', this._resizeEventEmiter)
  },
  methods: {
    _resizeEventEmiter () {
      return throttle(100, this.resizeHandle.emit.bind(this.resizeHandle))()
    }
  }
}
